// extracted by mini-css-extract-plugin
export default {"variant-default":"spinner_variant-default__gxfsP","variant-overlay":"spinner_variant-overlay__uhH98"};